export const SET_ERROR = 'SET_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'

export const setError = ({ domId, error }: { domId: string; error: any }) => {
  return {
    type: SET_ERROR,
    domId,
    error,
  }
}

export const clearError = (domId: string) => {
  return {
    type: CLEAR_ERROR,
    domId,
  }
}
